module.exports = __webpack_public_path__ + "static/d454efcfe393e15d8403902b098fed23df406556ddec2d35737c7794569b741f-f76ea0ed302bc137c314ee838b70a4f6.png";